/** Целое, ru-локаль. */
export const int0 = (n: number): string => Math.round(n).toLocaleString("ru-RU");

/** Число до 1 знака, ru-локаль. */
export const dec1 = (n: number): string =>
  n.toLocaleString("ru-RU", { minimumFractionDigits: 0, maximumFractionDigits: 1 });

/** Рубли без копеек, ru-локаль. */
export const rub0 = (n: number): string => `${int0(n)} ₽`;

/** Дата дд.мм.гггг (TZ-safe для YYYY-MM-DD). */
export function fmtDate(s: string | null | undefined): string {
  if (!s) return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (m) return `${m[3]}.${m[2]}.${m[1]}`;
  return String(s);
}

const MONTH_SHORT = ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"];
const MONTH_FULL = [
  "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
  "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь",
];

/** «янв 2025» из "2025-01". */
export function monthLabel(month: string): string {
  return `${MONTH_SHORT[Number(month.slice(5, 7)) - 1]} ${month.slice(0, 4)}`;
}

/** «Январь 2025» из "2025-01". */
export function monthFullLabel(month: string): string {
  return `${MONTH_FULL[Number(month.slice(5, 7)) - 1]} ${month.slice(0, 4)}`;
}

/** Относительное время «N назад» (для generated_at отчёта). */
export function timeAgo(iso: string): string {
  const min = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (min < 1) return "только что";
  if (min < 60) return `${min} мин назад`;
  const h = Math.round(min / 60);
  if (h < 24) return `${h} ч назад`;
  return `${Math.round(h / 24)} дн назад`;
}

/** Дельта со знаком: «+12» / «−5». */
export function signed(n: number): string {
  return n > 0 ? `+${int0(n)}` : int0(n);
}

/** Компактное число для осей: 1 200 000 → «1,2 млн», 45 300 → «45 тыс». */
export function compact(n: number): string {
  const abs = Math.abs(n);
  if (abs >= 1e6) {
    const v = n / 1e6;
    return `${v.toLocaleString("ru-RU", { maximumFractionDigits: abs >= 1e7 ? 0 : 1 })} млн`;
  }
  if (abs >= 1e3) return `${Math.round(n / 1e3).toLocaleString("ru-RU")} тыс`;
  return int0(n);
}
